module.exports = __webpack_public_path__ + "static/img/partner8.fa4e8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner8.png
// module id = v1V0
// module chunks = 1